import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { environment } from './environments/environment';
import { initGtm } from './analytics/gtm';

Sentry.init({
  dsn: environment.sentry.dsn,
  enabled: environment.sentry.enabled,
});

initGtm({ id: environment.gtm.id, enabled: environment.gtm.enabled });

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
